import React from 'react';
function useForwardedRef(forwardedRef) {
  var innerRef = React.useRef(null);
  React.useEffect(function () {
    if (!forwardedRef) {
      return;
    }
    if (typeof forwardedRef === 'function') {
      forwardedRef(innerRef.current);
    } else {
      forwardedRef.current = innerRef.current;
    }
  }, [forwardedRef]);
  return innerRef;
}
export default useForwardedRef;